import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
import Logo from 'assets/expressable-logo.svg?react';
import { LanguageSwitcher } from 'components/LanguageSwitcher';

type Props = { className?: string };

export const SignupHeader: React.FC<Props> = ({ className }) => {
  return (
    <header
      className={twMerge('w-full flex bg-cream-50 py-20 px-24 min-h-[88px] border-b border-black-12%', className)}
    >
      <div className={classNames('w-full flex items-center justify-between')}>
        <Logo className={classNames('fill-current text-black-100% w-auto h-24')} title="Expressable" />
        <LanguageSwitcher className="ml-16" position="left" />
      </div>
    </header>
  );
};
